import { render, staticRenderFns } from "./OrderView.vue?vue&type=template&id=5a30c3a3&scoped=true"
import script from "./OrderView.vue?vue&type=script&lang=js"
export * from "./OrderView.vue?vue&type=script&lang=js"
import style0 from "./OrderView.vue?vue&type=style&index=0&id=5a30c3a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a30c3a3",
  null
  
)

export default component.exports